/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
/**
 * Client information
 * @export
 * @interface GetClientInfo200Response
 */
export interface GetClientInfo200Response {
    /**
     * UUID of the client.
     */
    uuid?: string;
    /**
     * Display name of the client organization.
     */
    name?: string;
    /**
     * `monitoring` — continuous scanning; `audit` — one-shot security assessment.
     */
    mode?: GetClientInfo200ResponseModeEnum;
    /**
     * ISO 8601 datetime when this client was created.
     */
    createdAt?: Date;
    /**
     * Optional custom reference identifier (e.g. an external CRM ID). Null if not set.
     */
    clientRef?: string | null;
    /**
     * Employee count reported for this client, used for legacy billing.
     */
    reportedEmployeeCount?: number;
    /**
     * Current security score (0–100). Derived from active IoE findings and their criticalities.
     */
    securityScore?: number;
    /**
     * Internal GraphQL endpoint URL for this client's isolated database schema.
     */
    dataEndpoint?: string;
    /**
     * UUID of the serviceprovider managing this client.
     */
    serviceproviderUUID?: string;
}


/**
 * @export
 */
export const GetClientInfo200ResponseModeEnum = {
    Monitoring: 'monitoring',
    Audit: 'audit',
} as const;
export type GetClientInfo200ResponseModeEnum = typeof GetClientInfo200ResponseModeEnum[keyof typeof GetClientInfo200ResponseModeEnum];


/**
 * Check if a given object implements the GetClientInfo200Response interface.
 */
export function instanceOfGetClientInfo200Response(value: object): value is GetClientInfo200Response {
    return true;
}

export function GetClientInfo200ResponseFromJSON(json: any): GetClientInfo200Response {
    return GetClientInfo200ResponseFromJSONTyped(json, false);
}

export function GetClientInfo200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetClientInfo200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'uuid': json['uuid'] == null ? undefined : json['uuid'],
        'name': json['name'] == null ? undefined : json['name'],
        'mode': json['mode'] == null ? undefined : json['mode'],
        'createdAt': json['createdAt'] == null ? undefined : (parseDateTime(json['createdAt'])),
        'clientRef': json['clientRef'] === undefined ? undefined : json['clientRef'] === null ? null : json['clientRef'],
        'reportedEmployeeCount': json['reportedEmployeeCount'] == null ? undefined : json['reportedEmployeeCount'],
        'securityScore': json['securityScore'] == null ? undefined : json['securityScore'],
        'dataEndpoint': json['dataEndpoint'] == null ? undefined : json['dataEndpoint'],
        'serviceproviderUUID': json['serviceproviderUUID'] == null ? undefined : json['serviceproviderUUID'],
    };
}

export function GetClientInfo200ResponseToJSON(json: any): GetClientInfo200Response {
    return GetClientInfo200ResponseToJSONTyped(json, false);
}

export function GetClientInfo200ResponseToJSONTyped(value?: GetClientInfo200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'uuid': value['uuid'],
        'name': value['name'],
        'mode': value['mode'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : serializeDateTime(value['createdAt']),
        'clientRef': value['clientRef'],
        'reportedEmployeeCount': value['reportedEmployeeCount'],
        'securityScore': value['securityScore'],
        'dataEndpoint': value['dataEndpoint'],
        'serviceproviderUUID': value['serviceproviderUUID'],
    };
}

